import React from "react";
import {Nav, Navbar, NavDropdown, Container} from "react-bootstrap";
import {useLocation} from "react-router";

const infoPaths = ['/historiek', '/club-tournament', '/newmembers', '/training', '/ploegen', '/jeugd', '/senioren'];

export const Header = () => {
    const {pathname} = useLocation();
    const isActive = (path: string) => pathname.toLowerCase() === path.toLowerCase();
    const linkClass = (path: string) => isActive(path) ? 'ttc-nav-link active' : 'ttc-nav-link';

    return (
        <Navbar collapseOnSelect expand="lg" fixed={"top"} bg="white" variant={"light"} className={'ttc-navbar'}
                style={{zIndex: 2000}}>
            <Container>
                <Navbar.Brand href={'/'} className={'ttc-brand'}>
                    <span className={'ttc-brand-mark'}/>
                    <span className={'ttc-brand-name'}>TTC Bart Merksem</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" aria-label={'Menu'}/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link href='/home' className={isActive('/') ? 'ttc-nav-link active' : linkClass('/home')}>Home</Nav.Link>
                        <Nav.Link href='/board' className={linkClass('/board')}>Bestuur</Nav.Link>
                        <NavDropdown title="Info" id="basic-nav-dropdown"
                                     className={infoPaths.some(isActive) ? 'ttc-nav-link active' : 'ttc-nav-link'}>
                            <NavDropdown.Item href="/historiek">Historiek</NavDropdown.Item>
                            <NavDropdown.Item href="/club-tournament">Clubkampioenschap</NavDropdown.Item>
                            <NavDropdown.Item href="/newmembers">Nieuwe leden</NavDropdown.Item>
                            <NavDropdown.Item href="/training">Training</NavDropdown.Item>
                            <NavDropdown.Item href="/ploegen">Ploegen</NavDropdown.Item>
                            <NavDropdown.Item href="/jeugd">Jeugd</NavDropdown.Item>
                            <NavDropdown.Item href="/senioren">Senioren</NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Link href='/calendar' className={linkClass('/calendar')}>Kalender</Nav.Link>
                        <Nav.Link href='/documents' className={linkClass('/documents')}>Documenten</Nav.Link>
                        <Nav.Link href='/contact' className={linkClass('/contact')}>Contact</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}
